module.exports = __webpack_public_path__ + "static/media/times-circle.22024e54.svg";